export default class Shortcuts
{
    constructor() {
        document.addEventListener('keydown', e => {
            const key = e.key;

            // dashboard, calendar, planner - prev/next/home
            this.navigation(key);

            this.clearDropdownSearch(key);
        });
    }

    navigation(key) {
        if (!BS_EVENTS.hasOwnProperty('active_modal') && !BS_EVENTS.hasOwnProperty('running_tutorial')) {
            if (key === 'ArrowLeft') {
                const btn = document.getElementById('previous');
                if (!btn.classList.contains('button--disabled')) {
                    btn.click();
                }
            }

            if (key === 'ArrowRight') {
                const btn = document.getElementById('next');
                if (!btn.classList.contains('button--disabled')) {
                    btn.click();
                }
            }

            if (key === 'Home') {
                window.location.href = window.location.href.split('/').slice(0, -1).join('/');
                return;
            }
        }
    }

    clearDropdownSearch(key) {
        if (
            document.activeElement && document.activeElement.tagName === 'INPUT' &&
            document.activeElement.getAttribute('name') === 'search' && document.activeElement.closest('.dropdown')
            && key === 'Escape'
        ) {
            document.activeElement.value = null;
            const dd = document.activeElement.closest('.dropdown');
            dd.querySelectorAll('.dropdown__item').forEach(item => item.classList.remove('dropdown__item--hide'));
            dd.querySelectorAll('.dropdown__section')?.forEach(item => item.removeAttribute('style'));
            dd.querySelector('.no-match')?.remove();
        }
    }
}